import { Formik } from 'formik';
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { useQueryClient } from 'react-query';

import { useFollowUpdate } from '../../../../hooks';
import { autocompleteEntities } from '../../../../utils/backend-api/entities';
import { FollowAction, FollowType } from '../../../../utils/backend-api/follow';
import { AutoSave } from '../../../BaseUI';
import { AutocompleteField } from '../../../FormFields';

const INITIAL_FORM_STATE = { entity: { label: '', value: '' } };

interface AddTopicFormProps {
  identityId: number | string;
}

const AddTopicForm = ({ identityId }: AddTopicFormProps) => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateFollow } = useFollowUpdate();

  const handleSubmit = async (values, { resetForm }) => {
    if (!values.entity?.value) return;

    await updateFollow({
      followType: FollowType.Entity,
      followeeId: values.entity?.value,
      followAction: FollowAction.Follow,
      identityId: identityId,
      queryClient,
    });

    resetForm();
  };
  return (
    <Formik onSubmit={handleSubmit} initialValues={INITIAL_FORM_STATE}>
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          <div className="flexbox">
            <Col className="select-form-container">
              <AutocompleteField
                name="entity"
                className="mt0"
                isCreatable={false}
                fetchMethod={(value) =>
                  autocompleteEntities({
                    fragment: value,
                  })
                }
              />
            </Col>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddTopicForm;
